var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Livello 1",
    id: "Livello_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M101.39,92.84,96.22,39.68A32,32,0,0,0,77.67,13.59a13.67,13.67,0,0,0-27.33,0,32.05,32.05,0,0,0-18.55,26.1L26.6,92.9a15.09,15.09,0,0,0-13.6,15v3.87a3,3,0,0,0,3,3H42.3a24.39,24.39,0,0,0,43.4,0H112a3,3,0,0,0,3-3V107.1A14.32,14.32,0,0,0,101.39,92.84ZM64,6a7.67,7.67,0,0,1,7.35,5.44,33,33,0,0,0-14.69,0A7.67,7.67,0,0,1,64,6Zm0,116a18.34,18.34,0,0,1-14.64-7.26H78.65A18.29,18.29,0,0,1,64,122Zm45-13.26H19v-.87a9.09,9.09,0,0,1,9.11-9h1.22a3,3,0,0,0,3-2.71l5.43-55.85A26.07,26.07,0,0,1,54.43,18.37l.1,0a26.88,26.88,0,0,1,18.89,0l.32.12A26.09,26.09,0,0,1,90.25,40.26l5.43,55.85a3,3,0,0,0,3,2.71h2A8.31,8.31,0,0,1,109,107.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotification);
export default __webpack_public_path__ + "static/media/ic_notification.1fda0c7ffc27b584a7b581df0925e5e0.svg";
export { ForwardRef as ReactComponent };